import VueCookies from 'vue-cookies'
const state = {
  sidebar: {
    opened: VueCookies.get('sidebarStatus') ? !!+VueCookies.get('sidebarStatus') : true,
    withoutAnimation: false
  },
  device: 'desktop',
  size: VueCookies.get('size') || 'medium'
}

const mutations = {
  TOGGLE_SIDEBAR: (state, data) => {
    state.sidebar.opened = data
    state.sidebar.withoutAnimation = false
    VueCookies.set('sidebarStatus', data)
  },
  CLOSE_SIDEBAR: (state, withoutAnimation) => {
    VueCookies.set('sidebarStatus', 0)
    state.sidebar.opened = false
    state.sidebar.withoutAnimation = withoutAnimation
  },
  TOGGLE_DEVICE: (state, device) => {
    state.device = device
  },
  SET_SIZE: (state, size) => {
    state.size = size
    VueCookies.set('size', size)
  }
}

const actions = {
  toggleSideBar({ commit }, data) {
    commit('TOGGLE_SIDEBAR', data)
  },
  closeSideBar({ commit }, { withoutAnimation }) {
    commit('CLOSE_SIDEBAR', withoutAnimation)
  },
  toggleDevice({ commit }, device) {
    commit('TOGGLE_DEVICE', device)
  },
  setSize({ commit }, size) {
    commit('SET_SIZE', size)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
